@if (maneuverForm) {
	<div [formGroup]="maneuverForm">
		@if (isManeuverVisible) {
			<p>Please Select OB's :</p>
		}
		<div class="ob-selection-section">
			<mat-accordion [multi]="true" class="ob-selection-accordion">
				@for (OB of TS1_OB_LIST; track OB; let i = $index) {
					<mat-expansion-panel
						class="mat-elevation-z0"
						(opened)="panelOpenState = true"
						(closed)="panelOpenState = false"
						[expanded]="hasValue(OB.title)"
					>
						<mat-expansion-panel-header>
							<mat-panel-title>
								<div class="flex w-full flex-row items-center gap-2">
									<div class="size-2 rounded-full" [class.bg-red]="hasValue(OB.title)"></div>
									<span class="title whitespace-nowrap"
										><span class="font-bold"> {{ OB.title }}</span>
										<span class="text-lg font-bold">&nbsp;&#183;&nbsp;</span>
										{{ OB.desc }}
									</span>
									<div class="mx-2 flex-1 border-b border-b-black"></div>
								</div>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<!-- KNO -->
						@if (OB.title == "KNO") {
							<app-ob-container
								[obFormGroup]="KNO"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- PRO -->
						@if (OB.title == "PRO") {
							<app-ob-container
								[obFormGroup]="PRO"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- COM -->
						@if (OB.title == "COM") {
							<app-ob-container
								[obFormGroup]="COM"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- FPA -->
						@if (OB.title == "FPA") {
							<app-ob-container
								[obFormGroup]="FPA"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- FPM -->
						@if (OB.title == "FPM") {
							<app-ob-container
								[obFormGroup]="FPM"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- LTW -->
						@if (OB.title == "LTW") {
							<app-ob-container
								[obFormGroup]="LTW"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- PSD -->
						@if (OB.title == "PSD") {
							<app-ob-container
								[obFormGroup]="PSD"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- SAW -->
						@if (OB.title == "SAW") {
							<app-ob-container
								[obFormGroup]="SAW"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
						<!-- WLM -->
						@if (OB.title == "WLM") {
							<app-ob-container
								[obFormGroup]="WLM"
								[OB]="OB"
								(emitOBContainerValue)="onCheckBoxClick($event)"
							></app-ob-container>
						}
					</mat-expansion-panel>
				}
			</mat-accordion>
			@if (isSafetyOutcomeVisible) {
				<div class="my-8">
					<app-cbta-checkbox-rating
						name="safetyOutcome"
						label="TEM Safety Outcome"
						(ratingChange)="onRatingChange($event)"
						[rating]="5"
						[currentValue]="$safeNavigationMigration(safetyOutcome?.value)"
					>
					</app-cbta-checkbox-rating>
					<!-- <p>TEM Safety Outcome</p>
          <app-cbta-slider class="w-full" [steps]="5" [currentSliderValue]="safetyOutcome?.value ?? 0" (sliderChange)="onSafetyOutcomeSliderChange($event)"></app-cbta-slider> -->
					<input type="hidden" class="hidden" formControlName="safetyOutcome" [value]="safetyOutcome?.value ?? -2" />
				</div>
			}
			@if (isSafetyOutcomeVisible) {
				<div class="m-4 flex flex-row justify-between">
					<div class="grid grid-cols-3 gap-4">
						<button mat-stroked-button class="border !border-black !text-black" (click)="reaptConfirmModal()">
							Repeat
						</button>
					</div>
				</div>
			}
		</div>
	</div>
}
